import PropTypes from 'prop-types'
import NoneAnchor from 'components/NoneAnchor'
import { BaseCell } from 'features/dashboard/table/column/DashboardCells'
import { CampaignTypes, DashboardInfoTypes, ReviewStatus } from 'features/Codes'
import { isNullOrUndefined } from 'utils'
import NumberFormat from 'react-number-format'
import { batch, useDispatch, useSelector } from 'react-redux'
import { showCampaignDailyBudgetEdit } from 'features/dashboard/operation/campaignDailyBudgetEdit/campaignDailyBudgetEditSlice'
import Period from 'features/dashboard/table/shared/Period'
import CampaignLink from 'features/dashboard/shared/CampaignLink'
import { Link, useParams } from 'react-router-dom'
import { fetchDashboardInfoCampaign } from 'features/dashboard/info/dashboardInfoSlice'
import classNames from 'classnames'
import {
  addActives,
  dashboardTreeActions,
} from 'features/dashboard/tree/dashboardTreeSlice'

export const CampaignNameCell = ({
  value,
  row: {
    original: { id, deleted, type: campaignType },
  },
}) => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const {
    visible,
    type,
    id: campaignId,
  } = useSelector(state => state.dashboard.info)
  return (
    <BaseCell>
      <span className="thumb_link">
        {deleted ? (
          <span className="link_txt">{value}</span>
        ) : (
          <>
            <CampaignLink id={id} campaignType={campaignType}>
              {value}
            </CampaignLink>
            <div className="group_btn">
              <span className="link_modify">
                <Link
                  to={`/${adAccountId}/ads/campaigns/${id}`}
                  className="link_g">
                  <span className="ico_comm ico_modify">수정</span>
                </Link>
              </span>
              {visible && (
                <span
                  className={classNames('link_chart', {
                    on:
                      type === DashboardInfoTypes.CAMPAIGN && campaignId === id,
                    show:
                      type === DashboardInfoTypes.CAMPAIGN && campaignId === id,
                  })}>
                  <NoneAnchor
                    className="link_g"
                    onClick={() => {
                      batch(() => {
                        dispatch(dashboardTreeActions.setCampaignId(id))
                        dispatch(addActives(id))
                        dispatch(
                          fetchDashboardInfoCampaign({
                            id,
                            showError: true,
                          })
                        )
                      })
                    }}>
                    <span className="ico_comm ico_chart">캠페인 정보</span>
                  </NoneAnchor>
                </span>
              )}
            </div>
          </>
        )}
      </span>
    </BaseCell>
  )
}
CampaignNameCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      deleted: PropTypes.bool,
      type: PropTypes.oneOf([
        CampaignTypes.PREMIUM_LINK,
        CampaignTypes.TALK_CHANNEL,
      ]),
    }),
  }),
}

export const BizChannelCell = ({ value: { name, reviewStatus } }) => (
  <BaseCell>
    <span className="limit_line">{name}</span>(
    {ReviewStatus[reviewStatus].title})
  </BaseCell>
)
BizChannelCell.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string,
    reviewStatus: PropTypes.string,
  }),
}

export const CampaignDailyBudgetCell = ({
  value: dailyBudget,
  row: {
    original: { id, deleted },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showCampaignDailyBudgetEdit([id]))
    }
  }
  return (
    <BaseCell>
      <NoneAnchor className="align_r fc_emph" onClick={handleClick}>
        {isNullOrUndefined(dailyBudget) ? (
          '미설정'
        ) : (
          <NumberFormat
            value={dailyBudget}
            displayType="text"
            thousandSeparator
          />
        )}
      </NoneAnchor>
    </BaseCell>
  )
}
CampaignDailyBudgetCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      deleted: PropTypes.bool,
    }),
  }),
}

export const CampaignPeriodCell = ({
  row: {
    original: {
      period: { startDate, endDate },
    },
  },
}) => (
  <BaseCell>
    <Period startDate={startDate} endDate={endDate} parse="YYYYMMDD" />
  </BaseCell>
)
CampaignPeriodCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      period: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
      }),
    }),
  }),
}
